import React from 'react';
import { injectIntl } from 'react-intl';

import ListFilterAsyncMultiple from 'components/layout/list/ListFilterAsyncMultiple';
import { getNameInCurrentLanguage } from 'helpers/intl';

class ListFilterItem extends React.Component {
  listItemFormatter = item => {
    const intl  = {displayIntlForm: (this.props.intl.displayIntlForm ?? this.props.intl.locale) , ...this.props.intl};
    return typeof item?.name === 'object' ? getNameInCurrentLanguage(item.name, intl) : item?.name;
  };

  listItemId = item => {
    return item.id;
  };

  render() {
    const {
      intl: { messages },
      paramName,
      updateLocation,
      onUpdate,
      saveRef,
    } = this.props;

    return (
      <ListFilterAsyncMultiple
        title={messages.item}
        listName="items"
        listUrl="/api/items.json"
        listItemFormatter={this.listItemFormatter}
        listItemId={this.listItemId}
        paramName={paramName}
        updateLocation={updateLocation}
        onUpdate={onUpdate}
        saveRef={saveRef}
      />
    );
  }
}
ListFilterItem.defaultProps = {
  paramName: 'items',
  saveRef: () => {},
};

export default injectIntl(ListFilterItem);
